import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CONSENT_KEY } from './CookieConsentBanner';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const handleCookiePreferences = () => {
    try {
      window.localStorage.removeItem(CONSENT_KEY);
      window.dispatchEvent(new Event('glowapp-show-cookie-consent'));
    } catch (_) {}
  };

  const handleStartNow = () => {
    const appUrl = process.env.REACT_APP_APP_URL || 'https://glowapp.foo-tech.net';
    if (appUrl) {
      window.open(appUrl, '_blank');
    } else {
      console.error('App URL not configured');
    }
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo" aria-label={`${t('appName')} - Home`}>
              <span className="logo-icon" aria-hidden="true">⭐</span>
              <span className="logo-text">{t('appName')}</span>
            </Link>
            <p className="footer-description">{t('footerDescription')}</p>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">{t('quickLinks')}</h4>
            <ul className="footer-links">
              <li><a href="#features">{t('features')}</a></li>
              <li><a href="#benefits">{t('benefits')}</a></li>
              <li><a href="#pricing">{t('pricing')}</a></li>
              <li><a href="#faq">{t('faq')}</a></li>
              <li><a href="#contact">{t('contact')}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">{t('legal')}</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">{t('privacyPolicy')}</Link></li>
              <li><Link to="/terms">{t('termsOfService')}</Link></li>
              <li><button type="button" className="footer-link-button" onClick={handleCookiePreferences}>{t('cookiePreferences')}</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">{t('getStarted')}</h4>
            <button onClick={handleStartNow} className="btn btn-primary">
              {t('startNow')}
            </button>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {t('appName')}. {t('allRightsReserved')}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
